/**
 * O texto do cartão do ponteiro é curto: no máximo 3 linhas, o resto fica no `title` do parágrafo.
 * O ponteiro de verdade e a pré-visualização do admin usam esta mesma classe, então quem escreve
 * vê o corte que a pessoa vai ver.
 */
export const POINTER_BODY_CLASS = "line-clamp-3 text-sm leading-snug text-foreground-muted";
